import { useEffect, useRef, useState } from 'react';
import { CUSTOMERS, PRODUCTS } from '../data';
import { SYSTEMS, SHEETS, FS } from '../systems';
import { fmt, wait, rand } from '../helpers';
import { useStore, audit, setSys, updateSysUI } from '../store';

function SimpleTable({ rows }) {
  return (
    <div className="tbl-wrap"><table className="num">
      <thead><tr>{rows[0].map((h, i) => <th key={i}>{h}</th>)}</tr></thead>
      <tbody>{rows.slice(1).map((r, i) => <tr key={i}>{r.map((v, j) => <td key={j}>{String(v)}</td>)}</tr>)}</tbody>
    </table></div>
  );
}

function ErpTabs({ s }) {
  const { sysUI, quotes } = useStore();
  const tabs = s.id === 'sap'
    ? [['MARD · Depo stokları', () => [['Malzeme', 'Tanım', 'Depo', 'Serbest stok', 'Birim']].concat(PRODUCTS.map(p => [p.code, p.name, p.depot, p.stock, p.unit]))],
       ['KNA1 · Müşteri ana verisi', () => [['Müşteri', 'Ad', 'Şehir', 'VKN', 'Ödeme koşulu']].concat(CUSTOMERS.map(c => [c.id, c.name, c.city.split(' ').slice(1).join(' '), c.vkn, 'Z0' + c.payTerm]))],
       ['VBAK · Satış teklifleri', () => [['Belge no', 'Müşteri', 'Tarih', 'Net değer (TL)']].concat(quotes.map(q => [q.sapDoc || '-', q.customer.name, q.date, fmt(q.net)])).concat([['2000041872', 'ABC Endüstri A.Ş.', '22.09.2026', fmt(62000)], ['2000041851', 'Kuzey Hidrolik Makina San. A.Ş.', '17.09.2026', fmt(26062.5)]])]]
    : [['Cari hesaplar', () => [['Cari kod', 'Unvan', 'Borç bakiye (TL)', 'Limit (TL)', 'Vade']].concat(CUSTOMERS.map(c => ['120.01.' + c.id.slice(-3), c.name, fmt(c.openBalance), fmt(c.creditLimit), c.payTerm + ' gün']))],
       ['Stok kartları', () => [['Stok kodu', 'Açıklama', 'Birim', 'Satış fiyatı (TL)']].concat(PRODUCTS.map(p => [p.code, p.name, p.unit, fmt(p.price)]))]];
  return (
    <>
      <div className="seg" style={{ marginBottom: 12 }}>
        {tabs.map(([label], i) => (
          <button key={label} className={i === sysUI.erpTab ? 'on' : undefined} onClick={() => updateSysUI({ erpTab: i })}>{label}</button>
        ))}
      </div>
      <div><SimpleTable rows={tabs[sysUI.erpTab][1]()} /></div>
    </>
  );
}

function SheetView({ f, quotes, onClose }) {
  const rows = SHEETS[f.sheet](f.arg, quotes);
  const width = (rows[0].r || rows[0]).length;
  const letters = 'ABCDEFGHIJ';
  return (
    <div className="sheet">
      <div className="sheet-bar"><b>{f.name}</b><span>{rows.length - 1 + ' satır'}</span><button onClick={onClose}>Kapat</button></div>
      <div className="sheet-scroll">
        <table className="num">
          <thead><tr><th></th>{Array.from({ length: width }, (_, i) => <th key={i}>{letters[i]}</th>)}</tr></thead>
          <tbody>
            {rows.map((row, i) => (
              <tr key={i} className={i === 0 ? 'hdr' : (row.nw ? 'new' : undefined)}>
                <td className="rn">{String(i + 1)}</td>
                {(row.r || row).map((v, j) => <td key={j}>{String(v)}</td>)}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="sheet-foot"><span className="on">Sayfa1</span><span>Özet</span></div>
    </div>
  );
}

function Explorer({ s }) {
  const { sysUI, quotes } = useStore();
  const [file, setFile] = useState(null); // { f, path, loading }
  const path = sysUI.path;
  let node = FS[s.id];
  path.forEach(name => { node = node.children.find(c => c.name === name); });

  async function openFile(f) {
    const full = '\\\\' + s.host + '\\C$\\' + path.join('\\') + '\\' + f.name;
    setFile({ f, path: full, loading: true });
    setSys([s.id], true);
    await wait(rand(700, 1500));
    setSys([s.id], false);
    audit(s.name + ': ' + full + ' okundu');
    setFile({ f, path: full, loading: false });
  }

  if (file) {
    const { f, path: fp, loading } = file;
    if (loading) return <div><div className="opening">{f.name + ' ağ üzerinden okunuyor…'}</div></div>;
    return (
      <div>
        <button className="back" onClick={() => setFile(null)}>{'← ' + (path[path.length - 1] || 'C:') + ' klasörüne dön'}</button>
        {f.t !== 'xlsx'
          ? (
            <div className="noprev">
              <b>{f.name}</b><br />
              Konum: {fp}<br />
              Boyut: {f.size} · Değiştirilme: {f.date}<br />
              Bu dosya türü demoda önizlenmiyor. VİZOVA içeriği indeksleyip aramada kullanabilir.
            </div>
          )
          : <SheetView f={f} quotes={quotes} onClose={() => setFile(null)} />}
      </div>
    );
  }

  const label = { xlsx: 'X', pdf: 'PDF', docx: 'W', dwg: 'DWG', txt: 'TXT' };
  return (
    <div>
      <div className="crumbs">
        <button onClick={() => updateSysUI({ path: [] })}>{'\\\\' + s.host + '\\C$'}</button>
        {path.map((p, i) => [
          <span key={'s' + i}>›</span>,
          <button key={'b' + i} onClick={() => updateSysUI({ path: path.slice(0, i + 1) })}>{p}</button>
        ])}
      </div>
      <div className="files">
        <div className="frow head"><span></span><span>Ad</span><span className="dt">Değiştirilme</span><span className="sz">Boyut</span></div>
        {path.length > 0 && (
          <button className="frow" onClick={() => updateSysUI({ path: path.slice(0, -1) })}>
            <span className="fic dir"></span><span className="nm">..</span><span className="dt"></span><span className="sz"></span>
          </button>
        )}
        {node.children.slice().sort((a, b) => (a.t === 'dir' ? 0 : 1) - (b.t === 'dir' ? 0 : 1)).map(ch => (
          <button key={ch.name} className="frow"
            onClick={() => (ch.t === 'dir' ? updateSysUI({ path: [...path, ch.name] }) : openFile(ch))}>
            <span className={'fic ' + ch.t} style={{ fontSize: ch.t === 'xlsx' || ch.t === 'docx' ? '11px' : '7px' }}>{ch.t === 'dir' ? '' : label[ch.t]}</span>
            <span className="nm">{ch.name}</span>
            <span className="dt">{ch.date || ''}</span>
            <span className="sz">{ch.t === 'dir' ? ch.children.length + ' öğe' : ch.size}</span>
          </button>
        ))}
      </div>
    </div>
  );
}

function SystemDetail({ s }) {
  const [testing, setTesting] = useState(false);
  const [out, setOut] = useState({ cls: '', text: s.kind === 'erp' ? 'Durum: bağlı' : 'VİZOVA ajanı çalışıyor · salt okunur paylaşım' });
  const rows = s.kind === 'erp' ? s.info : [['Bilgisayar adı', s.host], ['Kullanıcı', s.user], ['IP adresi', s.ip], ['İşletim sistemi', s.os]];

  async function test() {
    setTesting(true); setOut({ cls: '', text: 'Test ediliyor…' });
    setSys([s.id], true);
    await wait(rand(1400, 2600));
    setSys([s.id], false);
    setOut({ cls: 'ok', text: 'Bağlantı başarılı · gecikme ' + rand(8, 46) + ' ms' });
    audit(s.name + ' bağlantı testi başarılı');
    setTesting(false);
  }

  return (
    <>
      <button className="back" onClick={() => updateSysUI({ open: null })}>← Bağlı sistemler</button>
      <div className="page-title">{s.name}</div>
      <div className="info">{rows.map(([k, v]) => <div key={k}><small>{k}</small>{v}</div>)}</div>
      <div className="toolbar">
        <button className="btn" disabled={testing} onClick={test}>Bağlantıyı test et</button>
        <span className={'test-out' + (out.cls ? ' ' + out.cls : '')}>{out.text}</span>
      </div>
      {s.kind === 'erp' ? <ErpTabs s={s} /> : <Explorer s={s} />}
    </>
  );
}

export function SystemsView() {
  const { sysUI } = useStore();
  const s = SYSTEMS.find(x => x.id === sysUI.open);
  if (s) return <SystemDetail key={s.id + sysUI.tick} s={s} />;
  return (
    <>
      <div className="page-title">Bağlı sistemler</div>
      <p className="page-sub">VİZOVA bu sistemlerden okuma yapar. Yazma işlemleri yalnızca onayınızla gerçekleşir.</p>
      <div className="sys-grid">
        {SYSTEMS.map(x => (
          <button key={x.id} className="sys-card" onClick={() => updateSysUI({ open: x.id, path: [], erpTab: 0, tick: Date.now() })}>
            <span className={'badge-ic ' + x.bg}>{x.short}</span>
            <b>{x.name}</b>
            <span className="line2">{x.kind === 'erp' ? x.sub : x.host + ' · ' + x.dept + ' · ' + x.user}</span>
            <span className="line3"><i></i><span>{x.kind === 'erp' ? 'Bağlı' : 'Bağlı · dosya sistemi ve Excel erişimi'}</span></span>
          </button>
        ))}
      </div>
    </>
  );
}

export function SystemsScroll({ children }) {
  const { sysUI } = useStore();
  const ref = useRef(null);
  useEffect(() => { if (ref.current) ref.current.scrollTop = 0; }, [sysUI.open, sysUI.tick]);
  return <div className="scroll" ref={ref}><div className="wrap">{children}</div></div>;
}
